module.exports = __webpack_public_path__ + "img/75725f5.png";